import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { EmsProvider } from "./state/EmsContext";
import { BrandProvider } from "./state/BrandContext";
import { App } from "./App";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: false, refetchOnWindowFocus: false },
  },
});

const element = document.getElementById("root");
if (!element) throw new Error("Root element not found");
createRoot(element).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <EmsProvider>
          <BrandProvider>
            <App />
          </BrandProvider>
        </EmsProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
